import { DOMAINS_SEO, ExamplesPageLayout } from "../../pagelayouts/examples";
import { APPLICATION_ROUTES } from "../../shared-logic/routes";

const ExampleJobPage = () => (
    <ExamplesPageLayout
        title={<>See real portfolio examples from professionals like you</>}
        description={<>Browse through hundreds of beautiful portfolio pages, curated by occupation, beat, topic, publication and more.</>}
        categoriesLinks={[]}
        panelLinks={DOMAINS_SEO}
        masonryItems={{ users: [] }}
        ogTitle={"Real Portfolio Examples from Writers & Creators | Authory"}
        ogDescription={
            "Browse real-world portfolio examples created by journalists, content creators, and thought leaders using Authory. See how they present their published work."
        }
        embedConf={[]}
        canonicalUrl={`${process.env.NEXT_PUBLIC_FRONTEND_URL}${APPLICATION_ROUTES.EXAMPLES}`}
        faq={[]}
    />
);

export default ExampleJobPage;
